import httpService from "./httpService";

export default {
  share(id, form) {
    return httpService.post(`hcCaseCalendar/${id}/share`, form);
  },

  joinRoom(id) {
    return httpService.post(`hcCaseCalendar/${id}/joinRoom`);
  },

  findAllWhichUsedRoom(params) {
    return httpService.get(`hcCaseCalendar/findAllWhichUsedRoom`, { params });
  },

  findByCaseMasterId(hcCaseMasterId) {
    return httpService.get(`hcCaseCalendar/findByCaseMasterId`, {
      params: { hcCaseMasterId }
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/hcCaseCalendarService.js